import styled from 'styled-components';
import { Card } from 'ui/card';
import { BUTTON_SIZES, SecondaryButton, TextButton } from 'ui/button';
import { Add16 } from 'ui/icons';
import { colors, spacing } from 'ui/theme';
import { AlertsModalType, useAlertsModalContext } from '../../context';
import { AlertsPageCard } from '../AlertsPageCard';
import { AlertWebhooksList } from './AlertWebhooksList';

export const StyledCard = styled(Card)`
  background: ${colors.white};
  display: flex;
  gap: ${spacing.plusHalf};
  flex-direction: column;
  padding: ${spacing.plusHalf};

  border: ${spacing.single} solid ${colors.grey15};
  border-radius: ${spacing.half};
`;

export const ActionsWrapper = styled.div`
  display: inline-flex;
  align-items: center;
  gap: ${spacing.base};
`;

export const ALERT_DESTINATIONS_CARD_ID = 'alert-destinations-card';

export const AlertDestinationCard = () => {
  const { openModal } = useAlertsModalContext();

  return (
    <AlertsPageCard
      data-test={ALERT_DESTINATIONS_CARD_ID}
      title={'Alert destination'}
      description={'Receive performance alert notifications outside of Iterable via webhooks.'}
      actions={
        <ActionsWrapper>
          <TextButton onClick={() => openModal(AlertsModalType.DisplayWebhookJSONAttributes)}>
            JSON Attributes
          </TextButton>

          <SecondaryButton
            size={BUTTON_SIZES.SMALL}
            onClick={() => openModal(AlertsModalType.AddWebhookModal)}
          >
            <Add16 />
            New webhook
          </SecondaryButton>
        </ActionsWrapper>
      }
    >
      <AlertWebhooksList />
    </AlertsPageCard>
  );
};
